import { useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
    trackPlayCount, 
    markVideoPlayed,
    selectIsVideoPlayed
} from '../store/user';

/**
 * 视频播放统计Hook
 * @param {Object} currentVideo - 当前视频对象
 * @param {Object} currentSeries - 当前系列对象
 * @returns {Object} - 包含播放统计相关的状态和方法
 */
export const useVideoTracking = (currentVideo, currentSeries) => {
    const dispatch = useDispatch();
    const [hasTrackedPlay, setHasTrackedPlay] = useState(false);
    
    // 从Redux获取播放状态
    const isVideoPlayed = useSelector(state => 
        currentVideo?.id ? selectIsVideoPlayed(state, currentVideo.id) : false
    );

    // 处理时间更新的回调
    const handleTimeUpdate = useCallback((currentTime) => {
        // 播放超过10秒且尚未统计时，触发播放统计
        if (currentTime >= 10 && !hasTrackedPlay && !isVideoPlayed && currentVideo?.id) {
            setHasTrackedPlay(true);
            
            // 先上报到服务器（API会处理重复提交检查）
            dispatch(trackPlayCount({ 
                articleId: currentVideo.id, 
                seriesId: currentSeries?.id 
            }));
        }
    }, [currentVideo?.id, currentSeries?.id, hasTrackedPlay, isVideoPlayed, dispatch]);

    // 重置播放统计状态（当视频切换时调用）
    const resetTracking = useCallback(() => {
        setHasTrackedPlay(false);
    }, []);

    return {
        hasTrackedPlay,
        isVideoPlayed,
        handleTimeUpdate,
        resetTracking
    };
}; 